<template>


<div class="row">
    <div class="main-banner">
<img :src="'./static/img/cortina-photo-banner.jpg'" class="img-responsive center-block" style="margin-top:150px;margin-bottom:100px;">
    </div>
<h1>CHOOSE<br>YOUR LEVEL</h1>
<div class="level-container">
 <div v-for="btn in levelBtn" :key="btn">
   <!-- <div v-if="btn === 'standard'">
     <div class="col-md-12">
        <router-link :to="{path:`/Frendel/${btn}`}">
       <div class="level-btn">
         {{btn}}
       </div>
        </router-link>
     </div>
   </div> -->
  <div class="col-md-6">
    <router-link :to="{path:`/Frendel/${btn}`}">
    <div class="level-btn">{{btn}}</div>
    </router-link>
    </div>
 </div>
</div>
</div>


</template>

<script>
import Material from '../../static/deco-touchscreen-export.json'
import _ from 'lodash'
// import uniq from 'lodash/uniq'
export default {
  name: 'Frendel',
  data () {
    return {
      msg: 'Frendel',
      Materials: Material,
      levelBtn:[],
      Categories:[]
    }
  },
  methods:{
  getLevel:function(e){
       this.new = null;
       this.new=Material;
       var i = 0;
  var newLevel = [];
       for(i==0;i<(this.new).length;i++){
         if((this.new)[i].Brand === 'Frendel'){
        newLevel.push((this.new)[i].Level)
         }
       }
      this.levelBtn =  _.uniq(newLevel);
    },
    loadCategories:function(level){
      var i = 0;
      var newCategories = [];
        for (i;i<Material.length;i++){
          if(Material[i].Level==level){
            newCategories.push(Material[i].Category)
          }
        }
          this.Categories = _.uniq(newCategories);
          console.log(this.Categories);
    }
  },
  mounted() {
    this.getLevel()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color:#d9272e;
  font-size: 80px;
  margin-top:83%;
}
h2{
  font-family: 'ralewaysemibold';
  font-size: 40px;
  font-style: italic;
  line-height: 50px;
  margin:70px;
}

h3{
  color:#d9272e;
  font-size: 40pt;
  font-weight: 100;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #333333;
}
.col-md-6{
  padding:5px;
}
.col-md-12{
  padding:5px;
}
.level-btn{
  width: 100%;
  padding: 25px;
  margin: 5px auto;
  font-family: 'ralewaysemibold';
  background-color: #d9272e;
  color: #ffffff;
  font-size: 30px;
  text-transform: uppercase;
}
.level-container{
  margin:auto;
  width: 80%;
}

.hide{
  display: none;
  transition: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Frendel.vue